module.exports = __webpack_public_path__ + "static/media/etp.061d85c3.svg";